/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – namnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
const initData = {
    type: '1',
    office: '1',
    working_date: '2025/12/31',
    workday_title: '1',
    workday_number: '1',
    reporter_cd: '',
    reporter_nm: '',
    comment_date: '2025/08/29',
    comment_number: '856739',
    comment_person: '伊藤　蓮',
    comment_content: '',
    schedules: [
        { no: '01', time: '08:30', content: '朝礼・養生' },
        { no: '02', time: '09:00', content: '搬入・開梱' },
        { no: '03', time: '12:00', content: '昼休憩' },
        { no: '04', time: '13:00', content: '開梱・組立補助' },
        { no: '05', time: '16:15', content: '終了' }
    ],
    places: [
        {
            id: 0,
            order_no1: 'MVJ0214618',
            order_no2: '2',
            onsite_meetings: ['1', '2', '6'],
            onsite_meetings2: ['1'],
            daytime: '1',
            business_partners: ['2'],
            customer_name: '株式会社陽光　大阪物流センターテクニカル課',
            billing_name: 'プライムプラネットエナジー&ソリューションズ姫路',
            time_start: '08:30',
            time_end: '16:15',
            quantity: '7',
            intention_to_arrange: '現場経験のため',
            actions_and_results: '周りを見てコミュニケーションをとりながら行動できた。',
            business_details: '新規什器搬入（4t×2台・2t×1台）・開梱・組立補助作業',
            impressions:
                '先週と同じ現場だったので、また同じ物量があるのかと身構えていましたが、かなり少なかったです。机の数がない分、天板が少なかったのでそれが大きかったです。',
            business_improvement_points: '特になし',
            project_sharing: '1',
            project_sharing_content: '',
            information_sharing: '1',
            information_sharing_content: '',
            other: '現場前、現場後に他業務をした際はこちらに記載',
            action_plan_date: '2025/09/01',
            action_plan_note: 'オフィス',
            issues: '手配＋新規スタッフ稼働'
        },
        {
            id: 1,
            order_no1: '',
            order_no2: '',
            onsite_meetings: [],
            onsite_meetings2: [],
            daytime: '1',
            business_partners: [],
            customer_name: '',
            billing_name: '',
            time_start: '',
            time_end: '',
            quantity: '',
            intention_to_arrange: '',
            actions_and_results: '',
            business_details: '',
            impressions: '',
            business_improvement_points: '',
            project_sharing: '1',
            project_sharing_content: '',
            information_sharing: '1',
            information_sharing_content: '',
            other: '',
            action_plan_date: '',
            action_plan_note: '',
            issues: ''
        }
    ],
    department_action_plan: '',
    department_progress_report: '',
    date_of_occurrence: '2025/08/01',
    occurrences_fiscal_year: '10',
    sales_budget_all_company: '3300000000',
    sales_budget_west_japan: '1000000000',
    arrangement_budget_west_japan: '64516',
    arrangement_budget_group_1: '31048',
    arrangement_budget_group_2: '27089',
    arrangement_budget_tennoji: '12364',
    arrangement_budget_namba: '8369',
    arrangement_budget_nishi_kujo: '8369',
    arrangement_budget_kobe: '7800',
    arrangement_budget_himeji: '1317',
    arrangement_budget_umeda: '12838',
    arrangement_budget_osaka_nishi_amagasaki: '1825',
    arrangement_budget_kyobashi: '5734',
    arrangement_budget_kyoto: '4947',
    arrangement_budget_shiga: '1745',
    arrangement_budget_creative: '1584',
    arrangement_budget_outsourcing_count: '530',
    arrangement_budget_sporty: '3905',
    west_japan: '360',
    //data for type 2
    office_arrangement_progress: '25期受注・手配進捗 - Google スプレッドシート',
    arrangement_intention: '本日手配した中の手配意図で共有すべき内容を記入。手配サイドからの教育・育成したいスタッフなど',
    other: '現場前、現場後に他業務をした際はこちらに記載',
    action_plan_date: '2025/09/01',
    action_plan_note: 'オフィス',
    issues: '手配＋新規スタッフ稼働',
    business_details: '新規什器搬入（4t×2台・2t×1台）・開梱・組立補助作業',
    impressions:
        '先週と同じ現場だったので、また同じ物量があるのかと身構えていましたが、かなり少なかったです。机の数がない分、天板が少なかったのでそれが大きかったです。',
    business_improvement_points: '特になし'
};
export default {
    namespaced: true,
    state: {
        data: JSON.parse(JSON.stringify(initData)),
        optionGroup: {
            type: [
                { code: 1, name: '現場' },
                { code: 2, name: 'オフィス' }
            ],
            office: [
                { code: 1, name: '新宿' },
                { code: 2, name: '船橋' }
            ],
            workday_title: [
                { code: 1, name: '通常業務' },
                { code: 2, name: '打合せ' },
                { code: 3, name: 'その他' }
            ],
            workday_number: [{ code: 1, name: '1' }],
            onsite_meetings: [
                { code: 1, name: '仕事の心得仕様', note: '※未使用の場合は経緯を【作業内容・所感】で報告' },
                { code: 2, name: '朝礼（点呼・制服備品確認・現場前ＭＴＧ）' }
                // { code: 3, name: '昼礼（点呼・昼ＭＴＧ）', note: '※ショート現場の場合' },
                // { code: 4, name: '有り' },
                // { code: 5, name: '無し' },
                // { code: 6, name: '終礼（点呼・終了報告・現場後ＭＴＧ）', note: '※未使用の場合は経緯を【作業内容・所感】で報告' },
                // { code: 7, name: '一人現場のため未実施' }
            ],
            onsite_meetings2: [
                { code: 1, name: '終礼（点呼・終了報告・現場後ＭＴＧ）', note: '※未使用の場合は経緯を【作業内容・所感】で報告' },
                { code: 2, name: '一人現場のため未実施' }
            ],
            business_partners: [
                { code: 1, name: '名刺交換', note: '※後日、上長報告（eightに転記）' },
                { code: 2, name: '終了報告' }
            ],
            yes_no_option: [
                { code: 1, name: '情報共有あり' },
                { code: 2, name: 'なし' }
            ],
            daytime: [
                { code: 1, name: '有り' },
                { code: 2, name: '無し' }
            ]
        }
    },
    mutations: {
        resetFormData(state, type) {
            state.data = JSON.parse(JSON.stringify(initData));
            state.data.type = type;
        }
    },
    actions: {}
};
